import React from 'react';
import { FormattedMessage } from 'react-intl';
import './WishFinder.component.scss';
import { Field, reduxForm } from 'redux-form';
import { InputFieldComponent } from '../../atoms/inputField/InputField.component';
import { EFormName } from '../../../config/form-names.config';

const WishFinderFormComponent = (props: any) => {
  const { handleSubmit } = props;
  return (
    <form onSubmit={handleSubmit}>
      <FormattedMessage id='wish-finder.form.text-placeholder'>
        {(txt: any) => (
          <Field name='text' component={InputFieldComponent} label={txt} />
        )}
      </FormattedMessage>
    </form>
  );
};

export default reduxForm({
  form: EFormName.WISH_FINDER,
})(WishFinderFormComponent);
